<template>
  <div :class="{ 'prevent-scroll': scrollLock }" ref="productPageDiv">
    <div class="product-page" v-if="ready">
      <main-product
        :product="product"
        :content="content"
        :isGroupCoupon="isGroupCoupon"
      ></main-product>
      <related-commend />
      <div class="nav-buy">
        <div class="row">
          <v-expand-transition>
            <div v-show="showNavBuy" class="expande-section col pt-0">
              <div
                v-if="storeOpts != null && storeOpts.length > 1"
                class="col col-12"
              >
                <label>分店選擇</label>
                <v-select
                  class="pdpSelect"
                  :items="storeOpts"
                  v-model="storeGuid"
                  label="請選擇"
                  @click.native="selectOpen"
                  @input="inputClicked"
                  v-clickOutside
                >
                  <template slot="selection" slot-scope="data">
                    <span class="custom-storeOpts">{{ data.item.text }}</span>
                  </template>
                  <template slot="item" slot-scope="data">
                    <span class="custom-storeText">{{ data.item.text }}</span>
                  </template>
                </v-select>
              </div>
              <div v-else-if="variationOpts.length > 1" class="col col-12">
                <label>商品規格</label>
                <v-select
                  class="pdpSelect"
                  :items="variationOpts"
                  v-model="variationId"
                  label="請選擇"
                  @click.native="selectOpen"
                  @input="inputClicked"
                  v-clickOutside
                >
                  <template slot="selection" slot-scope="data">
                    <span class="custom-variationOpts">
                      {{ data.item.text }}
                    </span>
                  </template>
                  <template slot="item" slot-scope="data">
                    <span class="custom-variationText">
                      {{ data.item.text }}
                    </span>
                  </template>
                </v-select>
              </div>
              <div
                v-if="product.couponType !== 6 && !isGroupCoupon"
                class="col col-12 py-0"
              >
                <div class="row align-center justify-space-between">
                  <div class="col">
                    <div class="count-text">
                      數量
                      <span
                        v-show="qty == qtyMaxinum && isGroupCoupon == false"
                        class="message"
                      >
                        數量已達上限
                      </span>
                    </div>
                  </div>
                  <div class="col col-auto">
                    <div class="row align-center row--count-panel">
                      <div class="col">
                        <v-btn
                          class="btn-count"
                          fab
                          outlined
                          :disabled="qty == qtyMinimum"
                          @click="qty -= 1"
                        >
                          -
                        </v-btn>
                      </div>
                      <div class="col text-center font-weight-bold">
                        <span class="count">{{ qty }}</span>
                      </div>
                      <div class="col">
                        <v-btn
                          class="btn-count"
                          fab
                          outlined
                          :disabled="qty == qtyMaxinum"
                          @click="qty += 1"
                        >
                          +
                        </v-btn>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div v-if="product.couponType !== 6" class="col col-12 py-0">
                <div class="row align-center justify-space-between subtotal">
                  <div class="col col-12 py-0">
                    <hr />
                  </div>
                  <div class="col py-2">小計</div>
                  <div class="col col-auto py-2">
                    <span class="price" v-if="isGroupCoupon">
                      {{ product.paymentRestrict == 1 ? '' : '$' }}
                      {{ price.toLocaleString() }}
                    </span>
                    <span class="price" v-else>
                      {{ product.paymentRestrict == 1 ? '' : '$' }}
                      {{ (price * qty).toLocaleString() }}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </v-expand-transition>
          <div class="col col-12 py-2">
            <v-btn
              color="primary"
              v-if="
                !variationOpts.length &&
                  (storeOpts == null || !storeOpts.length)
              "
              disabled
              outlined
              block
            >
              已售完
            </v-btn>
            <v-btn
              v-else-if="product.couponType == 6"
              color="primary"
              :outlined="!isNextStepOn || submitting"
              :disabled="!isNextStepOn || submitting"
              block
              @click="confirmBuy"
            >
              {{ submitting ? '索取中' : isNextStepOn ? '立即索取' : buyText }}
            </v-btn>
            <v-btn
              v-else-if="product.paymentRestrict == 1"
              :disabled="!isNextStepOn"
              :outlined="!isNextStepOn"
              color="primary"
              block
              @click="pointWarn"
            >
              {{ isNextStepOn ? 'P幣兌換' : buyText }}
            </v-btn>
            <v-btn
              v-else
              :outlined="!isNextStepOn"
              :disabled="!isNextStepOn"
              color="primary"
              block
              depressed
              @click="confirmBuy"
            >
              {{ isNextStepOn ? '購買' : buyText }}
            </v-btn>
          </div>
        </div>
      </div>
      <!-- <create-overlay
        :is-show="isPolicyShow"
        @closeOverlay="closeOverlay"
      ></create-overlay> -->
    </div>
    <Spinner v-else bgc="#f6f6f6" />
  </div>
</template>
<script>
import MainProduct from '@/components/product/MainProduct.vue'
import RelatedCommend from '@/components/RelatedCommend'
import CreateOverlay from '@/components/shared/Overlay.vue'
import Spinner from '@/components/shared/Spinner.vue'

export default {
  name: 'ProductPage',
  components: {
    MainProduct,
    RelatedCommend,
    CreateOverlay,
    Spinner,
  },
  data: function() {
    return {
      showNavbarBuy: false,
      showNavBuy: false,
      buyableStores: [],
      storeOpts: [],
      storeGuid: '',
      variationId: '',
      variationOpts: [],
      qty: 1,
      qtyMinimum: 1,
      qtyMaxinum: 10,
      isGroupCoupon: false,
      price: 0,
      product: {},
      content: {},
      isPolicyShow: false,
      variation: 1,
      isNextStepOn: false,
      buyText: '立即搶購',
      ready: false,
      scrollLock: false,
      maintainScrollPosition: 0,
      productVariations: [],
      aboutblockactive: '',
      backtotopactive: '',
      piPoints: 0,
      submitting: false,
      isLimited: false,
      limitQty: 0,
    }
  },
  mounted: function() {
    window.addEventListener(
      'scroll',
      () => {
        this.showNavbarBuy = window.scrollY > 500
        if (
          document.getElementById('navbarbuy') != null &&
          window.scrollY > 500
        ) {
          const div = parseInt(
            document.getElementById('navbarbuy').offsetHeight
          )
          this.aboutblockactive = 'height:' + (div + 50) + 'px'
          this.backtotopactive = 'bottom:' + (div + 80) + 'px'
        } else {
          this.backtotopactive = 'bottom:95px'
        }
      },
      300
    )
    this.loadData()
  },
  methods: {
    inputClicked() {
      if (!this.isGroupCoupon) {
        this.productVariations.forEach(t => {
          if (t.id == this.variationId) {
            if (this.isLimited && t.quantity > this.limitQty) {
              this.qtyMaxinum = this.limitQty
            } else {
              this.qtyMaxinum = t.quantity
            }
          }
        })
      }
      this.selectClose()
    },
    selectOpen() {
      this.scrollLock = true
      this.$refs.productPageDiv.style.top = `-${window.scrollY}px`
    },
    selectClose() {
      const scrollY = this.$refs.productPageDiv.style.top
      this.maintainScrollPosition = scrollY
      this.scrollLock = false
      this.$nextTick(() => {
        window.scrollTo(0, parseInt(this.maintainScrollPosition) * -1)
      })
      this.$refs.productPageDiv.style.top = ''
    },
    getCoupon() {
      this.submitting = true
      api
        .makeOrder(
          this.product.bid,
          1,
          this.storeGuid,
          0, // 0 優惠券
          0,
          0,
          '',
          '',
          '',
          '',
          '',
          0,
          {},
          [],
          {},
          {},
          false
        )
        .then(res => {
          this.submitting = false
          this.$router.push({
            name: 'paymentResult',
            params: { status: 'success' },
            query: { couponType: 6, orderNo: res.data.OrderNumber },
          })
        })
        .catch(err => {
          this.submitting = false
          this.$router.push({
            name: 'paymentResult',
            params: { status: 'error', err: err },
            query: { couponType: 6 },
          })
        })
    },
    confirmBuy() {
      // if (
      //   !this.showNavBuy &&
      //   (!this.isGroupCoupon || this.storeOpts.length > 1)
      // ) {
      //   this.showNavBuy = true
      //   this.isPolicyShow = true
      //   return
      // }
      // if (this.variationOpts.length > 0 && this.variationId == '') {
      //   this.$bus.$emit('callAllert', {
      //     messageContent: '請選擇商品規格',
      //   })
      //   return
      // }

      // if (this.storeOpts.length > 0 && this.storeGuid == '') {
      //   this.$bus.$emit('callAllert', {
      //     messageContent: '請選擇分店',
      //   })
      //   return
      // }
      // if (this.product.deliveryType == '1') {
      //   const store = this.storeOpts.find(e => e.value === this.storeGuid)
      //   this.product.spec = store.text
      // } else {
      //   const variation = this.variationOpts.find(
      //     e => e.value === this.variationId
      //   )
      //   this.product.spec = variation.text
      // }
      this.closeOverlay()
      if (this.product.couponType == 6) {
        this.getCoupon()
      } else {
        this.$router.push({
          name: 'paymentInfo',
          params: {
            id: this.$route.params.id,
            qty: this.qty,
            qtyMinimum: this.qtyMinimum,
            qtyMaxinum: this.qtyMaxinum,
            // variation: this.variationId,
            variationOpts: this.variationOpts,
            storeGuid: this.storeGuid,
            storeOpts: this.storeOpts,
            deliveryType: this.product.deliveryType,
            productInfo: this.product,
          },
        })
      }
    },
    pointWarn() {
      // if (
      //   !this.showNavBuy &&
      //   (!this.isGroupCoupon || this.storeOpts.length > 1)
      // ) {
      //   this.showNavBuy = true
      //   this.isPolicyShow = true
      //   return
      // }
      this.$bus.$emit('callConfirm', {
        title: '提醒您',
        messageContent: '純點商品無法退換貨',
        leftBtnText: '返回',
        rightBtnText: '確認購買',
        left_cb: () => {
          return
        },
        right_cb: () => {
          this.confirmBuy()
        },
      })
    },
    closeOverlay: function() {
      this.showNavBuy = false
      this.isPolicyShow = false
    },
    goback: function() {
      history.back()
    },
    loadData: async function() {
      const id = this.$route.params.id
      let checkRes = null
      let checkSoldOut = null
      try {
        checkRes = await api.checkProduct(id)
        if (checkRes.code == '1000') {
          checkSoldOut = checkRes.data.isSoldOut
        }
      } catch {}
      api
        .getProduct(id)
        .then(res => {
          if (res.Code == 1140) {
            this.$bus.$emit('callAllert', {
              messageContent: '訊息傳送失敗(錯誤代碼:' + res.data.code + ')',
              callback: () => {
                history.back()
              },
            })
          }
          const data = res.data
          this.price = data.price
          this.isLimited = data.isLimited
          this.limitQty = data.maxQuantity
          this.buyableStores = data.buyableStores
          this.productVariations = data.variations
          this.product = {
            deliveryType: data.deliveryType,
            bid: data.bid,
            imagePath: data.imagePath,
            title: data.title,
            subTitle: data.subTitle,
            originalPrice: data.originalPrice,
            price: data.price,
            soldOut: checkSoldOut === null ? data.soldOut : checkSoldOut,
            offline: data.offline,
            dealStartTime: data.dealStartTime,
            dealEndTime: data.dealEndTime,
            isGroupCoupon: data.isGroupCoupon,
            paymentRestrict: data.paymentRestrict, // data.paymentRestrict
            couponType: data.couponType,
            saleMultipleBase: data.saleMultipleBase,
          }
          this.handleProductStatus()
          this.handleSelectAndQty()
          this.ga()
          api.getProductContent(id).then(res2 => {
            this.content = res2.data || {}
          })

          this.ready = true
        })
        .catch(err => {
          if (err.code) {
            this.$bus.$emit('callAllert', {
              messageContent: '系統錯誤(錯誤代碼:' + err.code + ')',
              callback: () => {
                history.back()
              },
            })
          } else {
            this.$bus.$emit('callAllert', {
              messageContent: '發生錯誤' + JSON.stringify(err),
              callback: () => {
                history.back()
              },
            })
          }
        })
    },
    handleProductStatus() {
      if (
        new Date(this.product.dealStartTime).getTime() > new Date().getTime()
      ) {
        this.buyText = '尚未開賣'
      } else if (
        new Date(this.product.dealEndTime).getTime() < new Date().getTime()
      ) {
        this.buyText = '販售結束'
      } else if (this.product.offline) {
        this.buyText = '已下架'
      } else if (this.product.soldOut) {
        this.buyText = '已售完'
        if (this.product.couponType === 6) {
          this.buyText = '索取完畢'
        }
      } else if (this.isLimited && !this.limitQty) {
        this.buyText = '已達限購數量'
        if (this.product.couponType === 6) {
          this.buyText = '已達索取數量'
        }
      } else if (this.product.paymentRestrict == 1) {
        this.buyText = 'P幣餘額讀取中'
        this.pollingPipoint()
      } else {
        this.isNextStepOn = true
      }
    },
    handleSelectAndQty() {
      if (this.product.deliveryType === 1) {
        this.storeOpts = []
        this.buyableStores.forEach(t => {
          this.storeOpts.push({
            text: t.name,
            value: t.id,
            disabled: t.isSoldOut,
          })
        })

        // if (this.storeOpts.length > 0) {
        //   this.storeGuid = this.storeOpts[0].value
        // }
        if (this.product.isGroupCoupon) {
          this.isGroupCoupon = true
          this.qty = this.product.saleMultipleBase
          this.qtyMinimum = this.product.saleMultipleBase
          this.qtyMaxinum = this.product.saleMultipleBase
        } else if (this.isLimited) {
          this.qtyMaxinum = this.limitQty
        }
      } else {
        this.variationOpts = []
        this.productVariations.forEach(t => {
          this.variationOpts.push({
            text: t.name,
            value: t.id,
            disabled: t.isSoldOut,
          })
        })

        // if (this.variationOpts.length > 0) {
        //   this.variationId = this.variationOpts[0].value
        // }
        this.productVariations.forEach(t => {
          if (t.id == this.variationId) {
            if (this.isLimited && t.quantity > this.limitQty) {
              this.qtyMaxinum = this.limitQty
            } else {
              this.qtyMaxinum = t.quantity
            }
          }
        })
      }
    },
    pollingPipoint() {
      let checkTime = 10
      if (localStorage.getItem('PI_POINTS')) {
        this.buyText = 'P幣餘額不足'
        this.piPoints = localStorage.getItem('PI_POINTS')
        if (this.piPoints >= this.product.price) this.isNextStepOn = true
      } else {
        const timer = setInterval(() => {
          checkTime--
          if (localStorage.getItem('PI_POINTS')) {
            this.buyText = 'P幣餘額不足'
            this.piPoints = localStorage.getItem('PI_POINTS')
            if (this.piPoints >= this.product.price) this.isNextStepOn = true
            clearInterval(timer)
          } else if (!checkTime) {
            this.buyText = 'P幣餘額取得失敗'
            clearInterval(timer)
          }
        }, 1000)
      }
    },
    ga() {
      gtag('event', 'view_item', {
        items: [
          {
            id: this.product.bid,
            name: this.product.title,
            price: this.product.price,
            category: this.product.deliveryType == 1 ? '票券' : '宅配',
          },
        ],
      })
    },
  },
  directives: {
    clickOutside: {
      bind(el, binding, vNode) {
        const bubble = binding.modifiers.bubble
        const handler = e => {
          if (bubble || (!el.contains(e.target) && el !== e.target)) {
            if (vNode.context.scrollLock) {
              vNode.context.selectClose()
            }
          }
        }

        el.__vueClickOutside__ = handler

        document.addEventListener('click', handler)
      },
      unbind(el, binding) {
        document.removeEventListener('click', el.__vueClickOutside__)
        el.__vueClickOutside__ = null
      },
    },
  },
  watch: {
    qty() {
      if (this.product.isGroupCoupon || this.product.paymentRestrict != 1)
        return
      this.isNextStepOn = this.piPoints >= this.qty * this.price
    },
  },
}
</script>

<style scoped lang="scss">
.product-page {
  padding-bottom: 62px;
}
.prevent-scroll {
  position: fixed;
  left: 0;
  right: 0;
  overflow-y: scroll;
}
.navbar-buy {
  transition: bottom 0.3s ease;
  bottom: -100%;
  &--active {
    bottom: 49px;
  }
}

.back-to-top {
  &--active {
    bottom: 200px;
  }
}

.custom-storeOpts {
  line-height: 24px;
}

.custom-storeText {
  padding: 12px 0;
}

.custom-variationOpts {
  line-height: 24px;
}

.custom-variationText {
  padding: 12px 0;
}

.nav-buy {
  background-color: #ffffff;
  border-top-left-radius: 8px;
  border-top-right-radius: 8px;
  font-size: 15px;
  position: fixed;
  z-index: 25;
  bottom: 0;
  left: 0;
  right: 0;
  padding: 16px;

  .col {
    padding-top: 1;
  }

  .row {
    &--count-panel {
      margin: 0 -10px;
      > .col {
        padding: 10px;
      }
    }
  }

  .price {
    font-size: 18px;
    font-weight: bold;
    color: #000000;
  }

  label {
    font-size: 15px;
    color: #4a4a4a;
    padding-bottom: 4px;
  }
  hr {
    border-top: #ededed;
    background-color: #ededed;
  }
  .pdpSelect {
    padding-top: 0;
    margin-top: 0;
    background-color: #f3f5f8;
    padding: 12px 15px 12px 14px;
    border-radius: 16px;
    ::v-deep {
      .v-input__slot {
        margin-bottom: 0;
      }
      .v-text-field__details {
        display: none;
      }

      .v-icon.v-icon {
        color: #9b9b9b;
        // font-size: 12px;
      }
      .v-label {
        color: #9b9b9b;
        &.v-label--active {
          display: none;
        }
      }
      .v-input__control > .v-input__slot:before {
        border-color: #ededed;
      }

      .v-input__control
        > .v-input__slot
        > .v-select__slot
        > .v-select__selections {
        flex-wrap: nowrap;
      }
    }
  }
  .count {
    display: inline-block;
    width: 24px;
    color: #000000;
    font-size: 18px;
  }
  .count-text {
    position: relative;
    display: inline-block;
    .message {
      position: absolute;
      left: 100%;
      top: 50%;
      margin-left: 24px;
      margin-top: -10px;
      border-radius: 2px;
      font-size: 11px;
      font-weight: bold;
      white-space: nowrap;
      background-color: #1da7fc;
      color: #ffffff;
      padding: 1px 4px;
      &::before {
        content: '';
        position: absolute;
        width: 7px;
        height: 7px;
        transform: rotate(-315deg);
        border-radius: 1px;
        background-color: #1da7fc;
        left: 0;
        top: 50%;
        margin-top: -3px;
        margin-left: -4px;
      }
    }
  }
  .btn-count {
    width: 44px;
    height: 44px;
    font-size: 15px;
    &.v-btn {
      color: #1da7fc;
      &.v-btn--disabled {
        color: #222222 !important;
        background-color: #d8d8d8;
        border-color: #d8d8d8;
        opacity: 0.3;
      }
    }
  }

  .btn-buy {
    padding-top: 12px;
    padding-bottom: 12px;
    background-color: #1da7fc !important;
    color: #ffffff;
    height: auto;
    font-size: 16px;
    font-weight: bold;
  }
}
.block-overlay {
  background-color: #545454;
  opacity: 0.3;
  width: 100vw;
  height: 100vh;
  position: absolute;
  top: 0;
  left: 0;
}
::v-deep .v-list-item--disabled {
  background-color: #f7f7f7;
  color: #9b9b9b;
}
</style>
